// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"c160baab","79":"28093bb1","200":"a5984140","258":"a5984140","376":"ce143a6b","415":"0aa65ddd","530":"a5984140","638":"d827afef","699":"0aa65ddd"}[chunkId] + ".chunk.css";
};